module.exports = __webpack_public_path__ + "images/thumb-d9639cb2d7eda3866a6a9a6fa635b15d.jpg";